import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "svg-icon svg-icon-3x" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "ps-4 fs-2 fw-bolder" }, "Nouvelle Exploitation", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "fs-5 fst-italic fw-light pt-2 mb-0" }, " AgriBEST est conçu pour réaliser un diagnostic à l’échelle de l’exploitation. Vous pouvez choisir de distinguer différents ateliers dans le cas où vos pratiques diffèrent de manière importante (ex. mixité bio / non-bio) ", -1)
const _hoisted_4 = {
  key: 0,
  class: "notice d-flex flex-column flex-sm-row align-items-center bg-light-danger rounded border-danger border border-dashed mb-9 p-6"
}
const _hoisted_5 = { class: "svg-icon svg-icon-2tx svg-icon-danger m-4" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-stack flex-grow-1\"><div class=\"fw-bold\"><h4 class=\"text-gray-800 fw-bolder\"> Pour changer votre statut en <em>agriculteur à titre principal ou secondaire</em>, merci de vous assurer que toutes vos exploitations disposent bien des informations suivantes : </h4><ul class=\"fs-6 text-gray-600\"><li>Numéro de Siret valide</li><li>Statut légal</li><li>Adresse renseignée</li><li>Otex sélectionné</li><li>SAU renseignée</li><li>Production sous SIQO renseignée</li><li>Numéro de pacage renseigné</li><li>Démarche biodiversité renseignée</li></ul></div></div>", 1)
const _hoisted_7 = {
  key: 1,
  class: "notice d-flex flex-column flex-sm-row align-items-center bg-light-danger rounded border-danger border border-dashed mb-9 p-6"
}
const _hoisted_8 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_9 = { class: "fw-bold" }
const _hoisted_10 = { class: "text-gray-800 fw-bolder" }
const _hoisted_11 = { class: "svg-icon svg-icon-2x svg-icon-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_ExploitationContent = _resolveComponent("ExploitationContent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "btn btn-white btn-active-primary p-5 col-12 mb-6 text-start",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'new-exploitation' })))
    }, [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_inline_svg, {
          src: require('@/../public/media/icons/duotune/general/gen035.svg')
        }, null, 8, ["src"])
      ]),
      _hoisted_2,
      _hoisted_3
    ]),
    (_ctx.mandatoryFieldToUpdate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
          ]),
          _hoisted_6
        ]))
      : _createCommentVNode("", true),
    (_ctx.getExploitationsToUpdate.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h4", _hoisted_10, [
                _createTextVNode(" Les exploitations signalées par le symbole "),
                _createElementVNode("span", _hoisted_11, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
                ]),
                _createTextVNode(" nécessitent la mise à jour de certains indicateurs requis dans le cadre d'un ou plusieurs projets auxquels vous participez. ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getExploitations, (exploitation, index) => {
      return (_openBlock(), _createBlock(_component_ExploitationContent, {
        key: _ctx.contentKey + exploitation.id,
        collapseDefault: index > -1,
        exploitation: exploitation,
        class: "mb-5 mb-xl-10",
        onUpdateExploitations: _cache[1] || (_cache[1] = ($event: any) => (_ctx.contentKey = _ctx.contentKey + 1))
      }, null, 8, ["collapseDefault", "exploitation"]))
    }), 128))
  ], 64))
}